import { render } from "./EventPageSidebar.vue?vue&type=template&id=9c53bae0&scoped=true"
import script from "./EventPageSidebar.vue?vue&type=script&lang=js"
export * from "./EventPageSidebar.vue?vue&type=script&lang=js"

import "./EventPageSidebar.vue?vue&type=style&index=0&id=9c53bae0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c53bae0"]])

export default __exports__